module.exports = __webpack_public_path__ + "static/media/cloud_download-24px.f523538a.svg";